module.exports = __webpack_public_path__ + "static/family-playing-by-golden-gate-bridge.ddc303f7.webp";